import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RecordingPolicyFetchFailedAction = {
	type: 'RECORDING_POLICY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RecordingPolicyFetchFailedAction => ({
	type: 'RECORDING_POLICY_FETCH_FAILED',
	payload,
});
